import { Box, Divider, Grid } from "@mui/material";
import type { JSX } from "react";
import type { TabularReportConfigurationForRunning } from "../../../../../../../../api/types/svTypes.ts";
import PartContainer from "../../../viewer/common/PartContainer.tsx";
import PreviewTabs from "../PreviewTabs.tsx";
import RequestCode from "../editor/code/RequestCode.tsx";
import ResponseCode from "../editor/code/ResponseCode.tsx";

interface Props {
  Parameters: JSX.Element;
  Preview: JSX.Element;
  ActionPanel: JSX.Element;
  isLoading: boolean;
  runState: TabularReportConfigurationForRunning;
  isQueryLoggingActive: boolean;
  sessionId: string;
}

const ViewContainer = ({
  Parameters,
  Preview,
  ActionPanel,
  isLoading,
  runState,
  isQueryLoggingActive,
  sessionId,
}: Props) => {
  return (
    <Box sx={{ display: "flex", overflow: "auto", height: "100%" }}>
      {Parameters}
      <Divider orientation="vertical" />
      <PreviewTabs
        GridView={
          <PartContainer
            sx={{ borderRight: "unset", p: "1.3rem", pt: 2, height: "100%" }}
            containerSx={{ position: "relative", gap: "1rem" }}
            caption="Preview"
            captionVariant="subtitle2"
            actions={ActionPanel}
          >
            {Preview}
          </PartContainer>
        }
        CodeView={
          <Grid
            container
            sx={{
              display: "grid",
              width: "100%",
              flexWrap: "nowrap",
              minWidth: "45rem",
              gap: 3,
              p: "1.3rem",
              overflow: "hidden",
              gridTemplateRows: "minmax(20%, auto) minmax(20%, auto)",
            }}
          >
            <RequestCode
              isLoading={isLoading}
              fields={runState.fields}
              sorting={runState.sort}
              isQueryLoggingActive={isQueryLoggingActive}
              sessionId={sessionId}
            />
            <ResponseCode isLoading={isLoading} />
          </Grid>
        }
      />
    </Box>
  );
};

export default ViewContainer;
